<div class="d-inline-flex">
  <ncp-button
    #addVaccinationButton
    [options]="btnVacOptions()"
  >
    <img
      [ngSrc]="assets.healthIcons.svg.outline.devices.syringe.src"
      width="18"
      height="18"
      alt="Add Vaccinations"
      class="healthIcon"
    />
  </ncp-button>

  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <form
      id="vaccinations_form"
      name="vaccinations_form"
      [formGroup]="form"
      #vFrm="ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit()"
    >
      <ncp-dropdown #vaccinationDesc [(options)]="vaccinationDescDDOptions" />

      <h5>{{translations.vaccinations}}</h5>

      <div class="d-flex flex-row gap-2 me-4">

        <div class="col-6">
          <label for="description" class="form-label">{{translations.description}}</label>
          <div id="description" class="d-flex flex-column form-text border border-1 rounded-2 border-secondary bg-secondary-subtle viewText m-0">
            @if(this.vaccinationDescDDOptions().value) {
              <div class="row">
                <div class="col-12 text-uppercase">
                  {{this.vaccinationDescDDOptions().value!.display_name}}
                </div>
              </div>
            } @else {
              -
            }
          </div>
        </div>

        <div class="col-6">
          <label for="brandName" class="form-label">{{translations.brand_name}}</label>
          <div id="brandName" class="d-flex flex-column form-text border border-1 rounded-2 border-secondary bg-secondary-subtle viewText m-0">
            @if(this.vaccinationDescDDOptions().value) {
              <div class="row">
                <div class="col-12 text-uppercase">
                  {{this.vaccinationDescDDOptions().value!.product_name}}
                </div>
              </div>
            } @else {
              -
            }
          </div>
        </div>

      </div>

      <ncp-date #vaccineDate [(options)]="vaccinationDateOptions" />
      <ng-template #vaccinesTemplate let-value>
        <div class="d-flex flex-row">
            <div class="col-6 text-wrap">{{ value.product_name }}</div>
            <div class="col-6 text-wrap">{{ value.display_name }}</div>
        </div>
      </ng-template>
    </form>
  </ncp-modal>
</div>
